import { useEffect } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import OnboardingLayout from "./components/OnboardingLayout";
import AlreadyRegistered from "./pages/AlreadyRegistered";
import Step from "./components/Step";
import Recommendation from "./pages/Recommendation";
import useScreenTracking from "./hooks/useScreenTracking";
import AppDownload from "./pages/AppDownload";
import Mixpanel from "./services/tracking";
import GenericLandingPage from "./pages/GenericLandingPage";
import FlowSelectorPage from "./pages/FlowSelectorPage";
import BMSLabelling from "./pages/BMSLabelling";
import { flowRegistry } from "./data/flows";

function App() {
  useScreenTracking();

  useEffect(() => {
    const handler = () => {
      // @ts-ignore
      if (window.Cookiebot.consent.statistics) {
        Mixpanel.init();
        Mixpanel.track("LandedOnPage", { path: window.location.pathname });
      }
    };

    window.addEventListener("CookiebotOnConsentReady", handler);

    return () => window.removeEventListener("CookiebotOnConsentReady", handler);
  }, []);

  return (
    <Routes>
      <Route path="/">
        {Object.values(flowRegistry).map((flow) => {
          if (!flow.landingPath) return null;
          if (flow.landingPath === "/") {
            return (
              <Route
                key={flow.id}
                index
                element={<GenericLandingPage flowId={flow.id} />}
              />
            );
          }
          return (
            <Route
              key={flow.id}
              path={flow.landingPath}
              element={<GenericLandingPage flowId={flow.id} />}
            />
          );
        })}
        <Route path="/steg" element={<OnboardingLayout />}>
          <Route index element={<Navigate to="/" />} />
          <Route path="/steg/:slug" element={<Step />} />
        </Route>
        <Route path="/rekommendation" element={<Recommendation />} />
        <Route
          path="/rekommendation-c"
          element={<Recommendation variant="B" />}
        />
        <Route path="/ladda-ner/:sessionId?" element={<AppDownload />} />
        <Route path="/redan-registrerad" element={<AlreadyRegistered />} />
        <Route path="/val" element={<FlowSelectorPage />} />
        <Route path="/bms" element={<BMSLabelling />} />
      </Route>
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}

export default App;
